import axios from "axios";
import Constants from "../../../components.constants.js";


export default {
  async getLanguagesForFieldAliasConfig(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.languagesUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getLanguagesForFieldAliasConfig][Store][Error occured while getting languages List--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getAllCustomMetadataFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.customMetadataUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllCustomMetadataFromServer][Store][Error occured while getting custom metadata List--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async addNewCustomMetadata(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
      let resp = await axios.post(Constants.customMetadataUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addNewCustomMetadata][Store][Custom Metadata add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addNewCustomMetadata][Store][Error occured while adding custom metadata--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async updateExistingCustomMetadata(context, payload = {}) {
    //payload : {params:{customMetadataId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.put(`${Constants.customMetadataUrl}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateExistingCustomMetadata][Store][CustomMetadata update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateExistingCustomMetadata][Store][Error occured while updating CustomMetadata--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async deleteExistingCustomMetadata(context, payload = {}) {
    //payload : {params:{customMetadataId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.delete(`${Constants.customMetadataUrl}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[deleteExistingCustomMetadata][Store][CustomMetadata Delete resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteExistingCustomMetadata][Store][Error occured while deleting CustomMetadata--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async getCustomMetadataInfoFromServer(context, payload = {}) {
    //payload : {params:{customMetadataId:"3422344231"}}

    try {
      let resp = await axios.get(`${Constants.customMetadataUrl}/${payload.params._id}`);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getCustomMetadataInfoFromServer][Store][Error occured while getting CustomMetadata info --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async isCustomMetadataAttachedToAnyAsset(context, payload = {}) {
    //payload : {params:{_id:"3422344231"}}

    try {
      let cId = payload.params._id;
      delete payload.params._id;
      let resp = await axios.get(`${Constants.fieldConfirmationUrl}/${cId}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[isCustomMetadataAttachedToAnyAsset][Store][Error occured while getting CustomMetadata confirmation info --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
};
